// extracted by mini-css-extract-plugin
module.exports = {"container":"quote_container___ZUM6","quote":"quote_quote__8dbUK","quotee":"quote_quotee__kzHwN","grid":"quote_grid__aAEa8"};